/**
 * Те, що компоненти ядра CRM (стрічка коментарів, вкладки-списки дітей) беруть
 * із `formContext` картки власника — клієнта, контакту, перевізника.
 *
 * Лише службове, що не редагують: `uuid`, `@id`, `_permissions`. Значень
 * полів ці компоненти не читають (`SPEC-002` §4.2).
 */
export interface CrmOwnerFormContextLike {
    values?: {
        uuid?: unknown
        '@id'?: unknown
        _permissions?: { update?: boolean; comment?: boolean }
        [key: string]: unknown
    }
}

/** Збережений власник: `uuid` і `@id`. Форма створення його ще не має. */
export interface CrmOwnerRef {
    uuid: string
    '@id': string
}

export const crmOwnerOf = (formContext: CrmOwnerFormContextLike | undefined): CrmOwnerRef | null => {
    const uuid = formContext?.values?.uuid
    const iri = formContext?.values?.['@id']

    return typeof uuid === 'string' && uuid !== '' && typeof iri === 'string' && iri !== ''
        ? { uuid, '@id': iri }
        : null
}
